<template>
<v-row justify="center">
  <v-col cols="5">
    <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition" >
      <card-loading :loadText="loadText"></card-loading>
    </v-dialog>
  </v-col>
</v-row>
</template>

<script>
  export default {
    name: 'dialogLoading',
    props: {
      loadText: {
        type: String,
        default: () => 'Carregando'
      },
    },
    data() {
      return {
        dialog: true
      }
    },
  }
</script>

<style scoped>
.v-dialog {
  border-radius: 45px !important;
}

</style>